import { ComponentHelper } from "../core/util/componentHelper";
import { TextBox, TextBoxField, TextBoxProps } from "../core/components/textBox";
import { Button } from "../core/components/button";
import { BaseComponentProps, BaseField } from "../core/components/baseComponentProps";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import { DynamicProps } from "../core/components/dynamic";
import { Entity } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import React from "react";
export default class NewPasswordTextBox extends React.Component<NewPasswordTextBoxProps, NewPasswordTextBoxState> {
    private factory = ComponentHelper.createFactory();


    constructor(props: NewPasswordTextBoxProps) {
        super(props)
        this.state = {
            value: props.value,
            isPasswordMasked: true
        }
    }

    componentDidUpdate(prevProps: TextBoxProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({ value: this.props.value });
        }
    }

    private setValue = (value: string) => {
        this.setState({ value: value }, () => {
            this.props.onChange(this.props.field, value)
        })
    }

    private handleGenPwClick = async (e) => {
        HTTPService.post<JsonResultClass>('Account/GeneratePassword', {
            useExtendedLogin: this._isExtendedLogin(this.props.field.useExtendedLogin, this.props.entity)
        })
            .then(result => {
                if (result.Code == 0) {
                    this.setValue(result.Data);
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });

    }

    private handleShowPwClick = (e) => {
        if (this.state.isPasswordMasked) {
            this.setState({ isPasswordMasked: false })
        }
        else {
            this.setState({ isPasswordMasked: true })
        }
    }

    private _isExtendedLogin = (useExtendedLogin: string | boolean | Function, entity) => {
        switch (typeof useExtendedLogin) {
            case 'function':
                return useExtendedLogin();
            case 'boolean':
                return useExtendedLogin;
            case 'string':
                return this.props.handleEval(useExtendedLogin, entity)
        }
    }

    private createTextBox = () => {
        const props = this.factory.getDefaultTextBoxProps();
        props.value = this.state.value;
        props.field.isPassword = this.state.isPasswordMasked;
        props.field.isNewPassword = true;
        props.field.maxLength = (this.props.field.isInnosoftUserPassword ?? true) ? this._isExtendedLogin(this.props.field.useExtendedLogin, this.props) ? 32 : 8 : null;
        props.onChange = (_, value: string) => {
            this.setValue(value);
        }
        props.field.triggerOnChange = true;
        return (
            <div className="textbox-with-buttons" style={{ flex: 1 }}>
                <TextBox {...props} />
            </div>
        );
    }

    render() {

        return (
            <>
                <div style={{ display: "flex", alignItems: "center", width: "100%", flexWrap: "wrap" }}>
                    {this.createTextBox()}
                    {
                        !this.props.field.disablePasswordGeneration &&
                        <Button
                            iconName="fa-solid fa-wand-magic"
                            handleClick={this.handleGenPwClick}
                            title={Helper.getTranslation("WebSMS.Login.GeneratePassword")} >
                        </Button>
                    }
                    <Button
                        buttonStyle={{ borderRadius: "var(--rounded-right)" }}
                        iconName={this.state.isPasswordMasked ? "fal fa-eye" : "fal fa-eye-slash"}
                        handleClick={this.handleShowPwClick}
                        title={this.state.isPasswordMasked ? Helper.getTranslation("WebSMS.Login.ShowPassword") : Helper.getTranslation("WebSMS.Login.HidePassword")}               >
                    </Button>
                </div>
            </>);
    }
}

export interface NewPasswordTextBoxProps extends TextBoxProps {
    field: NewPasswordTextBoxField;
    handleEval?(expression: string, prepare: {});
    entity?: Entity;
}

export interface NewPasswordTextBoxField extends TextBoxField {
    useExtendedLogin: boolean | string | Function;
    disablePasswordGeneration?: boolean;
    isInnosoftUserPassword?: boolean;
}

export interface NewPasswordTextBoxState {
    value: string;
    isPasswordMasked: boolean;
}